import React from "react";

const SubHeader = () => {
  return (
    <div className="sub-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-8">
            <ul className="info">
              <li>
                <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                erkanbuyukarslan@hotmail.com
              </li>
              <li>
                <i className="fa fa-id-card" aria-hidden="true"></i>Yetki
                Numaramız: <strong className="ms-1"> 2600931 - 2601031</strong>
              </li>
            </ul>
          </div>
          <div className="col-lg-4 col-md-4">
            <ul className="social-links">
              <li>
                <a
                  href="https://www.facebook.com/people/RBA-Gayrimenkul-Dani%C5%9Fmanlik/100063970334586/"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/rba.gayrimenkul/"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://rbagayrimenkul.sahibinden.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Sahibinden"
                >
                  <i className="fas fa-s" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.hepsiemlak.com/emlak-ofisi/rba-gayrimenkul-78503/rba-gayrimenkul-1494363"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Hürriyet Emlak"
                >
                  <i className="fas fa-chevron-up" aria-hidden="true"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.emlakjet.com/emlak-ofisleri-detay/rba-gayrimenkul-415052/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="EmlakJet"
                >
                  <i className="fas fa-home" aria-hidden="true"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
